import React from "react";

function IconPrint() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
      <path fill="#000" d="M17.229 9.916a1.354 1.354 0 100 2.709 1.354 1.354 0 000-2.709z"></path>
      <path
        fill="#000"
        fillRule="evenodd"
        d="M2.52 6.791l2.25-.25V2.24c0-.697.532-1.28 1.226-1.343 3.329-.308 6.679-.308 10.008 0a1.349 1.349 0 011.225 1.343V6.54l2.25.25c.83.093 1.515.692 1.716 1.503a15.6 15.6 0 010 7.518l-.198.8a.813.813 0 01-.789.617H17.23v2.527c0 .674-.51 1.238-1.181 1.305-3.357.336-6.74.336-10.096 0a1.312 1.312 0 01-1.181-1.305V17.23H1.79a.813.813 0 01-.788-.617l-.199-.8a15.6 15.6 0 010-7.518c.202-.81.887-1.41 1.717-1.503zm13.084-.407a56.336 56.336 0 00-9.208 0V2.491a52.819 52.819 0 019.208 0v3.893zm0 9.492a.401.401 0 00-.267-.373 49.115 49.115 0 00-8.674 0 .401.401 0 00-.267.378v3.591a49.11 49.11 0 009.208 0v-3.596zm3.969-.272h-2.344v-.36c0-.675-.51-1.239-1.181-1.306a50.024 50.024 0 00-.44-.042 2.024 2.024 0 00-.188-.03 41.259 41.259 0 00-8.84 0 2.021 2.021 0 00-.188.03c-.147.013-.293.027-.44.042a1.312 1.312 0 00-1.181 1.305v.36H2.427l-.045-.182a13.976 13.976 0 010-6.736.37.37 0 01.318-.279l2.256-.25a54.711 54.711 0 0112.088 0l2.255.25a.37.37 0 01.32.28c.548 2.211.548 4.523 0 6.735l-.046.183z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default IconPrint;
